import initialState from "./initialState";

export function InvPendingRevAndBrowseInvPeriodsReducer(
  state = initialState.InvPendingRevAndBrowseInvPeriodsSearchInfo,
  action
) {
  switch (action.type) {
    case "INV_PENDING_REV_AND_BROWSE_INV_SELECTION_REQUEST":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
